const facilityUsagesGroupResources = {
    labelAddress: 'Address',
    labelVisitMonth: 'Visit Month',
    labelMonthlyTotal: 'Monthly Total',
    headerVisitDate: 'Visit Date',
    headerVisitTime: 'Visit Time',
    warningMessage: 'All visits will be shown under the home club’s location.'
};
export default facilityUsagesGroupResources;